var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "so98wtb80a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v1255H0V0h1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gmb3h8vhyb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm0-8a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#so98wtb80a)",
    transform: "translate(-637 -457)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gmb3h8vhyb)",
    transform: "translate(637 457)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C21703",
    d: "M0 0h16v16H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.5b203bb42354406d32cc534c6b74cb23.svg";
export { ForwardRef as ReactComponent };